'use client';

if (typeof window !== 'undefined') {
  // Disable Next.js error overlay in development
  window.addEventListener('error', (e) => {
    // Check if related to hydration errors
    if (e.message.includes('Hydration') || 
        e.message.includes('Minified React error') || 
        e.message.includes('Text content did not match') ||
        e.message.includes('Warning: Expected server HTML') ||
        e.message.includes('attributes of the server rendered HTML')) {
      e.preventDefault();
      console.log('Suppressed Next.js error:', e.message);
    }
  });

  // Clean up Grammarly extension attributes if they exist
  const observer = new MutationObserver(() => {
    if (document.body) {
      if (document.body.hasAttribute('data-new-gr-c-s-check-loaded')) {
        document.body.removeAttribute('data-new-gr-c-s-check-loaded');
      }
      if (document.body.hasAttribute('data-gr-ext-installed')) {
        document.body.removeAttribute('data-gr-ext-installed');
      }
    }
  });

  // Start observing the document body for attribute changes
  observer.observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true
  });
}

export {};